import {UI} from "../../../../stem-core/src/ui/UIBase";
import {Messages} from "../../../Messages";
import {registerStyle, Theme} from "../../../../stem-core/src/ui/style/Theme";
import {BaseInput} from "../../../ui/Input";
import {BlinkButton} from "../../../ui/Button";
import {AuthHelper} from "../../../AuthHelper";
import {authFormService} from "../../../services/AuthFormService";
import {styleRule, StyleSheet} from "../../../../stem-core/src/ui/Style";
import {isIframe} from "../../../Utils";
import {authService} from "../../../../client/connection/services/AuthService";


export class GenericSignUpPasswordlessStyle extends StyleSheet {
    @styleRule
    textLink = this.themeProps.AUTH_LINK_STYLE;

    @styleRule
    signUpPanel = {
        position: "relative",
    };

    inputCommon = {
        marginTop: 18,
        marginBottom: 6,
    };

    @styleRule
    input = this.inputCommon;

    @styleRule
    dividerLine = {
        marginTop: 24,
        fontSize: "15px !important",
    };

    @styleRule
    button = {
        ...Theme.props.AUTH_BUTTON_STYLE,
        marginBottom: 24,
    };
}

// TODO: this class seems too complex. Maybe break it down in multiple classes and/or simplify it.
@registerStyle(GenericSignUpPasswordlessStyle)
export class GenericSignUpPasswordless extends UI.Element {
    createUserIfNotExists = true;
    receiveSecureCode = false;
    emailInputError = this.options.emailInputError;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            emailInputError: null,
            emailButtonLabel: Messages.continue,
            emailInputLabel: Messages.continueWithEmail,
            InputClass: BaseInput,
            ButtonClass: BlinkButton,
            onSignUpAction: () => AuthHelper.signUpAction(),
            inputPlaceholder: "",
        }
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.signUpPanel);
    }

    render() {
        return [
            this.getHeaderSection(),
            this.getEmailInputSection(),
            this.getFooterSection(),
        ];
    }

    getHeaderSection() {
        return null;
    }

    getEmailInputSection() {
        const {styleSheet} = this;
        const {emailInputLabel, emailButtonLabel, inputPlaceholder, InputClass, ButtonClass} = this.options;
        const {registrationMail} = authFormService;

        return [
            <InputClass ref="emailInput" label={emailInputLabel} className={styleSheet.input}
                        initialValue={registrationMail}
                        errorComponentId="signupError" error={this.emailInputError} onFocus={() => this.clearErrors()}
                        inputAttributes={{type: "email", testId: "signupEmail", placeholder: inputPlaceholder}}
                        onEnter={() => this.handleSubmit()} onChange={() => this.onEmailInputChange()}/>,
            <ButtonClass testId="continueWithCode" ref="continueWithCode" label={emailButtonLabel}
                         className={styleSheet.button} disabled={!this.canSubmit()}
                         onClick={() => this.handleSubmit()}/>
        ]
    }

    getFooterSection() {
        return null;
    }

    onEmailInputChange() {
        this.clearErrors();
        this.redraw();
    }

    getSignupRedirectUrl() {
        return window.location.origin;
    }

    getRequestPayload() {
        return {
            firstName: "",
            lastName: "",
            email: this.emailInput.getValue().trim(),
            redirectUrl: this.getSignupRedirectUrl(),
            withSignup: this.createUserIfNotExists,
            secure: this.receiveSecureCode
        };
    }

    canSubmit() {
        return this.hasFilledEmail();
    }

    async handleSubmit() {
        if (!this.canSubmit()) {
            return;
        }

        // Hide the mobile keyboard.
        this.continueWithCode.node.blur();
        try {
            await AuthHelper.requestLoginCode(this.getRequestPayload());
            if (!authService.isAuthenticated()) {
                this.signUpAction();
            }
        } catch (error) {
            console.log(error);
            this.emailInputError = error.message;
            this.redraw();
        }
    }

    signUpAction() {
        this.options.onSignUpAction();
    }

    hasFilledEmail() {
        return this.emailInput && this.emailInput.getValue();
    }

    clearErrors() {
        this.emailInputError = null;
        this.redraw();
    }

    onMount() {
        super.onMount();

        const fillDataAndRedraw = () => {
            const {registrationMail} = authFormService;

            // We might have an email or a password saved in the app state previously by what the user typed on the login
            // form (or the sign up form); if the user hasn't typed anything in any current input, fill it with that value
            // he previously filled.
            if (registrationMail && !this.emailInput.getValue()) {
                this.emailInput.setValue(registrationMail);
                this.redraw();
            }
        };
        this.attachUpdateListener(authFormService, fillDataAndRedraw);

        this.emailInput.focus();
        this.addListener("urlEnter", () => this.emailInput.focus());
        this.addListener("urlExit", () => authFormService.setRegistrationMail(this.emailInput.getValue()));
    }
}
